import React, { useState } from 'react';
import { Settings as SettingsIcon, Save, TestTube } from 'lucide-react';

const Settings = ({ settingsManager, showToast }) => {
  const [webhookUrl, setWebhookUrl] = useState(settingsManager.settings?.discordWebhook || '');

  const handleSave = () => {
    settingsManager.saveSettings({ discordWebhook: webhookUrl });
    showToast('success', 'Settings Saved', 'Your preferences have been saved');
  };

  const handleTest = async () => {
    if (!webhookUrl) {
      showToast('error', 'No URL', 'Please enter a webhook URL first');
      return;
    }

    try {
      const testEmbed = {
        title: '🧪 Test Message',
        description: 'Binance Analytics Pro webhook test',
        color: 15844367,
        timestamp: new Date().toISOString()
      };

      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ embeds: [testEmbed] })
      });

      if (response.ok) {
        showToast('success', 'Test Successful', 'Check your Discord channel');
      } else {
        showToast('error', 'Test Failed', `HTTP ${response.status}`);
      }
    } catch (error) {
      showToast('error', 'Test Failed', error.message);
    }
  };

  return (
    <div className="page-section">
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '8px' }}>
          Settings & Configuration
        </h2>
        <p style={{ fontSize: '16px', color: 'var(--text-secondary)' }}>
          Customize your trading analytics experience
        </p>
      </div>

      <div className="dashboard-card">
        <div className="card-header">
          <h3>
            <SettingsIcon size={16} style={{ marginRight: '8px' }} />
            Discord Integration
          </h3>
        </div>
        <div className="card-content">
          <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '16px' }}>
            Configure Discord notifications for market alerts
          </p>
          <div className="form-group">
            <label className="form-label">Discord Webhook URL</label>
            <input
              type="url"
              className="form-input"
              placeholder="https://discord.com/api/webhooks/..."
              value={webhookUrl}
              onChange={(e) => setWebhookUrl(e.target.value)}
            />
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '4px' }}>
              Get webhook URL: Discord Server Settings → Integrations → Webhooks → Create Webhook
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
            <button className="btn primary" onClick={handleSave}>
              <Save size={16} />
              Save Settings
            </button>
            <button className="btn secondary" onClick={handleTest}>
              <TestTube size={16} />
              Test Connection
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings